import {
	translateFileModel,
	translateFileModelArray,
	type FileModel,
	type FileModelFR
} from './FileModel';

export type FICIModel = { annexes: FileModel[]; content: string; file: FileModel };
export type FICIResponse = {
	annexes: FileModelFR[];
	contenuFICI: string;
	fichierFICI: FileModelFR;
};

export const translateFICIModel = (fici: FICIResponse): FICIModel => {
	return {
		annexes: translateFileModelArray(fici.annexes),
		content: fici.contenuFICI,
		file: translateFileModel(fici.fichierFICI)
	};
};
